export const MODALS = {
    PAYIN_TICKET_MANAGEMENT: 'payin_ticket_management',
    PAYIN_ORDER_CHECKS: 'payin_order_checks',
    PAYOUT_TICKET_MANAGEMENT: 'payout_ticket_management',
    PAYOUT_ORDER_CHECKS: 'payout_order_checks',
    PAYIN_TRADER_EDITOR: 'payin_trader_editor',
    PAYOUT_TRADER_ORDER: 'payout_trader_order',
} as const;
